import { toTranslationKey } from '@/utils/stringFormat';
import { maintenanceCategoriesKeys } from '@/consts/MaintenanceCategoriesKeys';
import { MaintenanceMixin } from '@/mixins/Maintenance';
import Loader from '@/components/loader/Loader.vue';
import scheduledMaintenanceDlg
  from "@/views/maintenance/scheduledMaintenance/scheduledMaintenanceDlg/scheduledMaintenanceDlg.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import {MaintenanceRequestStatus} from "@/enums/MaintenanceRequestStatus";
import moment from "moment";

export default {
  name: 'scheduledMaintenanceView',
  components: { Loader, scheduledMaintenanceDlg, ConfirmDlg },
  mixins: [MaintenanceMixin],
  data() {
    return {
      loading: true,
      additionalResponse: '',
      selectedTechnician: null,
      headers: [

        {
          text: 'Status',
          align: 'start',
          value: 'status',
        },
        {
          text: 'Creation Date',
          align: 'start',
          value: 'dateTimeD',
        },
        {
          text: 'Est. Completion Date',
          align: 'start',
          value: 'estimatedCompletionDate',
        },
        {
          text: 'Completion Date',
          align: 'start',
          value: 'completionDateD',
        },
        {
          text: 'Assigned To',
          align: 'start',
          value: 'assignee',
        },

        // {
        //   text: this.$i18n.messages[this.$i18n.locale][
        //     'MaintenanceList.RequestAge'
        //   ],
        //   align: 'start',
        //   value: 'requestAge',
        // },
      ],
      ticketPriority: null,
      ticketPriorityOptions: ['Low', 'Medium', 'High', 'Urgent'],
      estimatedDeliveryDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      menu: false,
    };
  },
  computed: {
    request() {
      return this.$store.state.maintenanceModule.currentSchedMaint;
    },
    maintenanceRequests() {
      const maintenanceRequests =
        this.$store.state.maintenanceModule.currentSchedMaintList

      return maintenanceRequests;
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    MaintenanceTechnicians() {
      return [...this.$store.state.userModule.maintenanceUsers, ...this.$store.state.userModule.maintenanceVendors.map(x => { return {...x, isVendor: true} })];
    },
  },
  async created() {
    await this.$store.dispatch('getScheduledMaintenanceById', this.$route.params.id);
    await this.$store.dispatch('getRequestsByScheduledMaintenanceId', this.$route.params.id);
    await this.$store.dispatch('getMaintenanceUsers');
    await this.$store.dispatch("getMaintenanceVendors");
    await this.$store.dispatch('getVendors');
    await this.$store.dispatch('getMaintenanceCategories');

    this.loading = false;
  },
  methods: {
    convertToTranslationKey(text) {
      return toTranslationKey(text);
    },
    routeToRequestList() {
      this.$router.push('/scheduledMaintenance');
    },
    async completeRequest() {
      await this.$store.dispatch('completeMaintenanceRequest', {
        id: this.$route.params.id,
        additionalResponse: this.additionalResponse,
      });
    },
    async assignRequest() {
      await this.$store.dispatch('assignMaintenanceRequest', {
        id: this.$route.params.id,
        assignee: this.selectedTechnician,
        estimatedCompletionDate: this.estimatedDeliveryDate,
        priority: this.ticketPriority,
      });
    },
    getColor(priority) {
      if (priority == 'Urgent' || priority == 'High') {
        return 'red--text';
      } else if (priority == 'Medium') {
        return 'orange--text';
      } else {
        return 'green--text';
      }
    },
    checkExistCategory(category) {
      const key = toTranslationKey(category);
      return maintenanceCategoriesKeys.includes(key);
    },
    updateScheduledMaintenance() {
      this.$refs.scheduledMaintenanceDlg.open('update', this.request);
    },
    deleteScheduledMaintenance() {
      this.$refs.confirmDlg.open(null, this.$t("MaintenanceSchedule.MaintenanceScheduleDeleteMessage"), false).then(async response => {
        if (response && response.agree) {
          await this.$store.dispatch("deleteScheduledMaintenance", this.request.id);

          this.$toast.open({
            type: "success",
            message: this.$t("MaintenanceSchedule.MaintenanceScheduleDeleteSuccess")
          });

          this.$router.push({ path: "/scheduledMaintenance" })
        }
      })
    },
    handleClickRequest(row): void {
      this.$router.push({ path: `/maintenanceRequests/${row.id}` });
    },
    getStatus(status) {
      switch (status) {
        case MaintenanceRequestStatus.New: {
          return this.$t("MaintenanceList.New");
        }
        case MaintenanceRequestStatus.InProgress: {
          return this.$t("MaintenanceList.InProgress");
        }
        case MaintenanceRequestStatus.Cancelled: {
          return this.$t("MaintenanceList.Cancelled");
        }
        case MaintenanceRequestStatus.Complete: {
          return this.$t("MaintenanceList.Completed");
        }
      }
    },
    isCompletedRequest(item) {
      if(
        (item.status === MaintenanceRequestStatus.Complete && item.completionDateD) ||
        (item.status === MaintenanceRequestStatus.Cancelled) ||
        ([MaintenanceRequestStatus.InProgress, MaintenanceRequestStatus.New].includes(item.status) && moment().format('YYYY-MM-DD') <= moment(item.estimatedCompletionDate).format('YYYY-MM-DD'))
      ) {
        return true;
      }

      return false;
    }
  },
};